import React from 'react';
import { ButtonsWrapper } from './style';

export default function ButtonsPlusAndCheck({ buttonAdd = true, buttonCheck = true }) {
  return (
    <ButtonsWrapper buttonCheck={buttonCheck}>
      {buttonAdd && (
        <button>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z" />
          </svg>
        </button>
      )}
      {buttonCheck && (
        <button>
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
            <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
          </svg>
        </button>
      )}
    </ButtonsWrapper>
  );
}
